<script setup lang="ts">
	const loaderFunc = useLoader()
	const { User } = reactor(useUser())
	const { confirmAccountVerification } = useUser()

	onBeforeMount(() => {
		if (User.value?.email_verified_at) {
			confirmAccountVerification()
		}
	})
</script>

<template>
	<div class="relative">
		<shared-top-nav class="border-b px-0" />
		<div class="px-4 sm:px-0">
			<slot />
		</div>
		<loader
			v-model:loading="loaderFunc.Loading"
			:loader-text="loaderFunc.loadingText"
			class="lg:max-w-screen left-0 max-w-full lg:left-[unset]"
		/>
	</div>
</template>

<style scoped>
	body {
		background: #fff;
	}
</style>
